import { createFileRoute } from '@tanstack/react-router';
import { CasinoCategoryPage } from '@/ui/casino';

export const Route = createFileRoute('/casino/$category/$vendor')({
  component: CasinoVendorRoute,
});

function CasinoVendorRoute() {
  const { category, vendor } = Route.useParams();
  return <CasinoCategoryPage category={category} vendorOrFlag={vendor} />;
}
